<script setup lang="ts">
import BottomSheetDialog from '@/components/Utilities/BottomSheetDialog.vue';
import TestReviewStatusFilter from '@/components/Student/TestReview/TestReviewStatusFilter.vue';

defineProps<{
    submittedFilters: string[];
}>();

defineEmits<{(event: 'apply-filters', filters: string[]): void }>();

</script>
<template>
    <BottomSheetDialog
        full-width
        title="Filter By"
        :enable-clear-all-btn="true"
        :enable-action-btns="false"
        @clear-all="() => { $emit('apply-filters', []) }"
    >
        <TestReviewStatusFilter
            :applied-filters="submittedFilters"
            @apply-filters="(filters: string[]) => { $emit('apply-filters', filters) }"
        />
    </BottomSheetDialog>
</template>
<style scoped>
.clear-all-button {
    bottom: 30px;
}
</style>
